<div class="loading__item image"></div>
<div class="loading__item title"></div>
<div class="loading__item description"></div>
<div class="loading__item title"></div>
<div class="loading__item textarea"></div>
<hr class="mb-1">
<div class="loading__item title"></div>
<div class="loading__item text"></div>
<div class="loading__item text"></div>
<div class="loading__item button"></div>